function i(r, e) {
  if (!(r != null && r.orderFormatSettings))
    return null;
  const { preparationTime: n = "" } = r.orderFormatSettings.find(
    (a) => a.orderFormat === e
  ) || {};
  return n;
}
export {
  i as default
};
